// Imports
// React and React Router
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// Components
import { AppRoutes } from './routes/AppRoutes';
import { AuthProvider } from './contexts/AuthContext';
import { DarkModeProvider } from './contexts/DarkModeContext';
import { UserProfileProvider } from './contexts/UserProfileContext';

// Styles
import './App.css';

// Component Definition
const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <DarkModeProvider>
          <UserProfileProvider>
            <AppRoutes />
          </UserProfileProvider>
        </DarkModeProvider>
      </AuthProvider>
    </Router>
  );
};

/**
 * App: Main application component
 * Sets up the routing, authentication context, dark mode context and user profile context
 * @returns The App component
 */
export default App;
